module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-four.f7fbcaa2.png";